'use client';

import { useState } from 'react';

import { BasicAlert } from '../../../../icons/basic';
import { ImagePreview } from './ImagePreview';

export interface PreviewProps {
  file: File;
  className?: string;
  error?: boolean;
}

export function Preview(props: PreviewProps) {
  const [loadingError, setLoadingError] = useState<boolean>(props.error ?? false);
  const hasError = props.error || loadingError;

  return (
    <figure className="relative size-[3.625rem] min-w-[3.625rem] flex-col bg-upload-disabled">
      {hasError && (
        <span className="absolute left-1/2 top-1/2 size-7 -translate-x-1/2 -translate-y-1/2 text-icon-disabled">
          <BasicAlert />
        </span>
      )}
      {!hasError && (
        props.file.type === 'application/pdf' ? (
          <span className="absolute left-1/2 top-1/2 size-7 -translate-x-1/2 -translate-y-1/2 text-icon-disabled">
            PDF
          </span>
        ) : (
          <ImagePreview
            file={props.file}
            error={props.error}
            onError={() => setLoadingError(true)}
            className="block aspect-square h-full object-cover object-center"
          />
        )
      )}
    </figure>
  );
}
